import { Link as RouterLink } from 'react-router-dom'
import type { ComponentProps } from 'react'

type Props = Omit<ComponentProps<'a'>, 'href'> & {
  href: string
  /** Accepted and ignored — react-router has no equivalent and none is needed
   *  for an app whose routes are already lazy-loaded chunks. */
  prefetch?: boolean
  replace?: boolean
}

/**
 * `next/link`, over react-router. Aliased in `vite.config.ts`; see the note in
 * `next-navigation.ts` for why this is a shim and not sixteen edits.
 *
 * External links and anchors must NOT go through the router — it would try to
 * match `https://…` or `mailto:` as a route and land on the catch-all. The
 * five call sites include `target="_blank"` links, so this is not theoretical.
 */
export default function Link({ href, prefetch: _prefetch, replace, ...rest }: Props) {
  const isExternal = /^([a-z]+:)?\/\//i.test(href) || /^(mailto:|tel:)/i.test(href)
  if (isExternal || href.startsWith('#')) {
    return <a href={href} {...rest} />
  }
  return <RouterLink to={href} replace={replace} {...rest} />
}
